import { render, staticRenderFns } from "./scanIndex.vue?vue&type=template&id=b12305a6&scoped=true"
import script from "./scanIndex.vue?vue&type=script&lang=js"
export * from "./scanIndex.vue?vue&type=script&lang=js"
import style0 from "./scanIndex.vue?vue&type=style&index=0&id=b12305a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12305a6",
  null
  
)

export default component.exports